import { useEffect, useMemo, useState } from 'react'
import type { SiteDocument } from '../data/documents'
import { getLocale, localizeNode, localizeValue } from '../i18n/locales'
export function DocumentPage({ document: sourceDoc }: { document: SiteDocument }) {
 const locale = getLocale()
 const doc = useMemo(() => localizeValue(locale, sourceDoc), [locale, sourceDoc])
 const updatedDate = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' }).format(new Date('2026-09-05T00:00:00Z'))
 const [active, setActive] = useState(window.location.hash.slice(1) || doc.sections[0].id)
 useEffect(() => {
  const observer = new IntersectionObserver(entries => {
   const visible = entries.filter(e => e.isIntersecting).sort((a,b) => a.boundingClientRect.top - b.boundingClientRect.top)
   if (visible[0]) setActive(visible[0].target.id)
  }, { rootMargin: '-100px 0px -55% 0px', threshold: 0 })
  doc.sections.forEach(s => { const el = window.document.getElementById(s.id); if (el) observer.observe(el) })
  return () => observer.disconnect()
 }, [doc])
 return localizeNode(locale, <main id="main-content" className="shell document-page" tabIndex={-1}>
  <header className="document-heading"><h1>{doc.title}</h1><p className="lead">{doc.intro}</p><p className="document-date">Last updated <time dateTime="2026-09-05">{updatedDate}</time></p></header>
  <div className="document-layout"><nav className="document-toc" aria-label="On this page"><h2>On this page</h2>{doc.sections.map(s => <a href={`#${s.id}`} key={s.id} aria-current={active === s.id ? 'location' : undefined} onClick={() => setActive(s.id)}>{s.title}</a>)}</nav>
  <article className="document-body"><div className="document-summary"><h2>The short version</h2><p>{doc.summary}</p></div>{doc.sections.map(s => <section id={s.id} key={s.id}><h2>{s.title}</h2>{s.body}</section>)}</article></div>
 </main>)
}
